module.exports = __webpack_public_path__ + "img/box-arrow-up.da4c0bf3.svg";